import React from "react";
import {
    Route,
    Routes, useParams,
} from "react-router-dom";
import Dashboard from "../Pages/Dashboard";
import DynamicComponent from "../Utils/DynamicComponent";
import { pascalCase } from "../../utils/string/change-case";
import DevLog from "../Pages/DevLog";
import Stock from "../Pages/Stock";
import Docs from "../Pages/Docs";

const Components = () => {
    let { components } = useParams();
    return <DynamicComponent
        path={"Pages/" + pascalCase(components)}
    />
}

export default () => {
    return (
        <>
            <style>
                {`
                .punch-knife-preview {
                    display: block;
                    .mantine-UnstyledButton-root {
                        width: 100% !important;
                        .mantine-Image-root {
                            width: 100% !important;
                            height: auto !important;
                            min-width: 0;
                            max-width: initial !important;
                        }
                    }
                }
                .mantine-Autocomplete-dropdown {
                    z-index: 999999 !important;
                    /*position: fixed !important;*/
                }
                .editor-modal {
                    min-height: 100%;
                    > .mantine-Modal-inner {
                        > .mantine-Modal-content {
                            display: flex;
                            flex-direction: column;
                            min-height: 100%;
                            > .mantine-Modal-header {
                                flex: 0 0 auto;
                            }
                            > .mantine-Modal-body {
                                display: flex;
                                flex-direction: column;
                                flex: 1 1 auto;
                                flex-grow: 1;
                                > div {
                                    display: flex;
                                    flex-direction: column;
                                    flex: 1 1 auto;
                                    flex-grow: 1;
                                    > form {
                                        display: flex;
                                        flex-direction: column;
                                        flex: 1 1 auto;
                                        flex-grow: 1;
                                        .editor-actions {
                                            margin-top: auto;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                `}
            </style>
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/:components" element={<Components />} />
                <Route path="/stock" element={<Stock />} />
                <Route path="/docs" element={<Docs />} />
                <Route path="/devLogs" element={<DevLog />} />
            </Routes>
        </>
    );
}